// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"style_tooltipWrapper__VBZVf"};